<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <button class="btn-delete" @click="$emit('delete')">
        <svg-icon
          icon-name="ic-corbeille"
          color="$couleur-primaire"
          className="iconeCorbeille"
        ></svg-icon>
      </button>
      <button class="btn-close" @click="$emit('close')">
        <svg-icon
          icon-name="ic-fermer1"
          color="$couleur-primaire"
          className="iconeFermer"
        ></svg-icon>
      </button>
      <div class="modal-body">
        <span>{{ message.createDate }}</span
        ><br />
        <h3>{{ messagesBienJouer[message.messageCode].msgTitre }}</h3>
        <br /><br />
        <p>{{ messagesBienJouer[message.messageCode].msgDetail }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageModal',
  props: {
    message: {
      type: Object,
      required: true,
    },
    messagesBienJouer: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
}
.btn-delete {
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 8px 16px;
  .iconeCorbeille {
    color: black;
    width: 1.75em;
    height: 1.75em;
  }
}
.btn-close {
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 8px 16px;
  .icone-fermer {
    color: black;
  }
}
.modal-body {
  margin-top: 40px; /* espace pour ne pas être recouvert par les boutons */
}
</style>
